import { lazy, Suspense } from "react";
import { RouteObject } from "../../helpers/tixxt-router";
import Loading from "../shared/Loading";

const InboxPage = lazy(() => import("../../components/messages/InboxPage"));
const SentPage = lazy(() => import("../../components/messages/SentPage"));
const NewMessagePage = lazy(
  () => import("../../components/messages/NewMessagePage"),
);
const ShowMessagePage = lazy(
  () => import("../../components/messages/ShowMessagePage"),
);

const routes: RouteObject[] = [
  {
    path: "/messages",
    element: (
      <Suspense fallback={<Loading />}>
        <InboxPage />
      </Suspense>
    ),
  },
  {
    path: "/messages/sent",
    element: (
      <Suspense fallback={<Loading />}>
        <SentPage />
      </Suspense>
    ),
  },
  {
    path: "/messages/new",
    element: (
      <Suspense fallback={<Loading />}>
        <NewMessagePage />
      </Suspense>
    ),
  },
  {
    path: "/messages/:messageId",
    element: (
      <Suspense fallback={<Loading />}>
        <ShowMessagePage />
      </Suspense>
    ),
  },
];

export default routes;
